import { QuickTipsTranslation } from '@/assets/locales/views/processes/list/quickTips/quickTips.translation.en.ts';

export const quickTipsTranslation: QuickTipsTranslation = {
  processDetailsAction:
    'Aby szybko zobaczyć pełne szczegóły procesu rekrutacyjnego, kliknij przycisk „Zobacz” w kolumnie Akcje. Otworzy to stronę szczegółową, na której można przejrzeć wszystkie informacje dotyczące wybranego procesu.',
  processDetailsActionTitle: 'Używanie kolumny Akcje do przejścia do szczegółów procesu',
  quickTips: 'Wskazówki',
  toggleRequirements:
    'Jeśli zawartość kolumny „Wymagania” jest skrócona, kliknij opcję rozwinięcia, aby zobaczyć pełną listę kwalifikacji i umiejętności wymaganych na dane stanowisko. Pozwoli Ci to dokładnie zapoznać się z kryteriami procesu na pierwszy rzut oka.',
  toggleRequirementsTitle: 'Rozwijanie kolumny Wymagania, aby zobaczyć pełną treść',
};
